import FormSelect from 'components/Select/FormSelect';
import Text from 'components/Text/Text';
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import SearchField from 'components/SearchField/SearchField';
import style from './MultipleSelect.module.scss';

interface IMultipleSelect {
	data: IItemForGetShortInfo[];
	isLoading: boolean;
	refetch: () => void;
	responseError: boolean;
	setIDsCategories: (value: string[]) => void;
	IDsSelectedRestaurant: string[];
	IDsSelectedCategories: string[];
}

const MultipleSelect: React.FC<IMultipleSelect> = ({
	data,
	isLoading,
	refetch,
	responseError,
	IDsSelectedRestaurant,
	IDsSelectedCategories,
	setIDsCategories,
}) => {
	const [searchString, setSearchString] = useState<string>('');

	const filteredData = useMemo(() => {
		return searchString ? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase())) : data;
	}, [searchString, data]);

	const handleSelectAllData = useCallback(() => {
		if (data.length === IDsSelectedCategories.length) {
			setIDsCategories([]);
		} else {
			const IDsOfAllDishes = data.map((el) => el.id);
			setIDsCategories(IDsOfAllDishes);
		}
	}, [data, IDsSelectedCategories, setIDsCategories]);

	useEffect(() => {
		setSearchString('');
	}, [IDsSelectedRestaurant]);

	const renderSelectMenu = useCallback(
		(menu: React.ReactElement) => {
			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={!!(data.length && data.length === IDsSelectedCategories.length)}
							disabled={!data.length}
							onChange={handleSelectAllData}>
							<Text
								translationNameSpace="form"
								translationKey="selectAllCategoriesLabel"
								asFragment={true}
							/>
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		},
		[data, IDsSelectedCategories, handleSelectAllData, setSearchString, searchString],
	);

	return (
		<FormSelect
			name="IDsSelectedCategories"
			label="categoriesLabel"
			options={filteredData}
			fetchError={responseError}
			loading={isLoading}
			onRefetch={refetch}
			disabled={!IDsSelectedRestaurant.length || isLoading}
			onChange={setIDsCategories}
			counterValue={IDsSelectedCategories.length}
			dropdownRender={renderSelectMenu}
			mode="multiple"
		/>
	);
};

export default React.memo(MultipleSelect);
